import React from "react";
import { Link } from "gatsby";
import { responsiveImage, PHOTO_WIDTHS } from "../../utils/responsiveImage";

const heroImage = responsiveImage("/assets/home/hero-multimarca", PHOTO_WIDTHS);

const ESPECIALIDADES = "Coloración · Cuidado capilar · Biocosmética · Uñas · Depilación · Herramientas · Tijeras · Mobiliario";

/**
 * Primer impacto de la home. Su H1 es el único de la página.
 * Sin bajada: el documento pide que el titular hable solo.
 */
const Hero = () => (
	<section id="inicio" className="anchor-target bg-paper py-10 lg:py-[42px] lg:pb-[54px]">
		<div className="shell grid items-center gap-8 lg:grid-cols-[minmax(0,.88fr)_minmax(0,1.12fr)] lg:gap-12 xl:gap-16">
			<div className="flex flex-col items-start">
				<p className="eyebrow">Belimport · Uruguay</p>

				<h1 className="display-1 my-5 max-w-[720px] lg:mb-7 lg:mt-5">
					Marcas para la belleza profesional
				</h1>

				<p className="mb-7 max-w-[630px] text-[9px] font-semibold uppercase leading-relaxed tracking-[.07em] text-muted lg:mb-8 lg:text-[11px]">
					{ ESPECIALIDADES }
				</p>

				<div className="flex w-full flex-col items-stretch gap-2.5 sm:w-auto sm:flex-row sm:items-center">
					<Link className="button button--primary" to="/#marcas">
						Conocer las marcas <span aria-hidden="true">→</span>
					</Link>
					<Link className="button button--quiet" to="/#promociones">
						Ver promociones
					</Link>
				</div>
			</div>

			<figure className="m-0 aspect-video overflow-hidden bg-white shadow-editorial lg:aspect-[16/10]">
				<img
					src={ heroImage.src }
					srcSet={ heroImage.srcSet }
					sizes="(min-width: 1024px) 58vw, 100vw"
					alt="Productos de las marcas que importa Belimport: coloración, cuidado capilar, uñas, depilación y herramientas"
					width="1920"
					height="1080"
					className="h-full w-full object-cover"
				/>
			</figure>
		</div>
	</section>
);

export default Hero;
